import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  value: number;
  onChange: (value: number) => void;
}

export const NextDaysFilterDropdown = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  const nextDaysOptions = useMemo(() => {
    const arr = Array.from({ length: 90 }, (_, i) => i + 1).filter(
      (day) => day >= 7 && day <= 90,
    );
    return arr.map((day) => ({ value: day, label: `${day} ${t('laDays')}` }));
  }, [t]);

  return (
    <Autocomplete
      options={nextDaysOptions}
      getOptionLabel={(option) => option.label}
      sx={{ width: 150, marginLeft: 2 }}
      value={nextDaysOptions.find((option) => option.value === value) || null}
      onChange={(_e, value) => {
        onChange(value?.value || -1);
      }}
      renderInput={(params) => (
        <TextField {...params} size="small" label={t('laNext')} />
      )}
    />
  );
};
